module.exports = __webpack_public_path__ + "img/bannerimg1.642e54ee.png";